import { GetterTree } from 'vuex';

import {
  InvoicesStateI,
} from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<InvoicesStateI, RootStateI> = {
};
